import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "app" }
const _hoisted_2 = {
  key: 0,
  class: "dev"
}
const _hoisted_3 = { class: "flex-center-between px-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Copyright © 2023 GPT Craft", -1)
const _hoisted_5 = { class: "flex-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  href: "mailto:andreykypaku@gmail.com",
  class: "underline ml-2"
}, "Andrey Kypaku", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ApolloPlayground = _resolveComponent("ApolloPlayground")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CookieConsent = _resolveComponent("CookieConsent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view),
    (_ctx.isDev())
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_ApolloPlayground)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("footer", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: "legal",
          class: "mr-2"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Legal")
          ]),
          _: 1
        }),
        _createTextVNode(" Made by "),
        _hoisted_6
      ])
    ]),
    _createVNode(_component_CookieConsent)
  ]))
}